export default "__VITE_ASSET__DCfMEXpK__"